import { isUndefined } from 'lodash';
import type { RGB } from 'shared/types';

export const hexToRGB = (hex: string, alpha?: number) => {
  const r = parseInt(hex.slice(1, 3), 16),
    g = parseInt(hex.slice(3, 5), 16),
    b = parseInt(hex.slice(5, 7), 16);

  if (alpha) {
    return `rgba(${r},${g},${b},${alpha})`;
  } else {
    return `rgb(${r},${g},${b})`;
  }
};

/**
 * Converts RGB color values from 16-bit (0-65535) to 8-bit (0-255).
 * COPC point clouds typically store RGB values as 16-bit integers. This function
 * converts them to 8-bit for standard web rendering (0-255 range).
 */
export const convertRgb16To8 = (
  red16?: number,
  green16?: number,
  blue16?: number,
): RGB => {
  return {
    r: isUndefined(red16) ? 0 : Math.floor(red16 / 256),
    g: isUndefined(green16) ? 0 : Math.floor(green16 / 256),
    b: isUndefined(blue16) ? 0 : Math.floor(blue16 / 256),
  };
};
